export default __webpack_public_path__ + "static/media/greenCheckmark.b9ca346d.svg";